package navigation.home.crm

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.essntl.components.sidepanel.SidePanel
import com.essntl.components.sidepanel.SizeConstraint
import com.essntl.components.sidepanel.Splitter
import com.essntl.components.sidepanel.rememberSidePanelState
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.contactdetails.ContactDetailsScreen
import com.essntl.features.crm.ui.CRMEvent
import com.essntl.features.crm.ui.CRMNavigation
import com.essntl.features.crm.ui.CRMScreen
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationEvent
import com.essntl.features.crm.ui.contactorganization.ContactOrganizationScreen
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.organization.ui.OrganizationEvent
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.link.NavLinkState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import navigation.home.address.AddressScreenModel
import navigation.home.contact.ContactScreenModel
import navigation.home.crm.contactorganization.ContactOrganizationScreenModel
import navigation.home.customfields.CustomFieldsScreenModel
import navigation.home.organization.OrganizationScreenModel
import navigation.home.organization.organizationdetails.OrganizationDetailsScreenNav
import navigation.home.travelagents.addedittravelagent.AddEditTravelAgentScreenModel
import navigation.utils.NavLinkScreen
import navigation.utils.safePush
import org.koin.core.qualifier.named

object CRMScreenNav : NavLinkScreen {
    override val defaultTitle: String = "Contacts"

    override var navLinkState: NavLinkState by mutableStateOf(
        NavLinkState(
            title = defaultTitle,
            iconRes = EsIcons.Suppliers,
        ),
    )

    @Composable
    override fun Content() {
        val crmScreenModel = koinScreenModel<CRMScreenModel>()
        val crmState by crmScreenModel.state.collectAsState()

        val contactScreenModel = koinScreenModel<ContactScreenModel>()
        val contactState by contactScreenModel.state.collectAsState()

        val contactOrganizationScreenModel = koinScreenModel<ContactOrganizationScreenModel>()
        val contactOrganizationState by contactOrganizationScreenModel.state.collectAsState()

        val organizationScreenModel = koinScreenModel<OrganizationScreenModel>()
        val organizationState by organizationScreenModel.state.collectAsState()

        val organizationAddressScreenModel = koinScreenModel<AddressScreenModel>(named("organization"))
        val organizationAddressState by organizationAddressScreenModel.state.collectAsState()

        val contactAddressScreenModel = koinScreenModel<AddressScreenModel>(named("contact"))
        val contactAddressState by contactAddressScreenModel.state.collectAsState()

        val customFieldsScreenModel = koinScreenModel<CustomFieldsScreenModel>()
        val customFieldsState by customFieldsScreenModel.state.collectAsState()

        val travelAgentScreenModel = koinScreenModel<AddEditTravelAgentScreenModel>()
        val travelAgentState by travelAgentScreenModel.state.collectAsState()

        val navigator = LocalNavigator.currentOrThrow

        val sidePanelState =
            rememberSidePanelState(
                sidePanelVisible = false,
                panelSizeConstraint =
                    SizeConstraint(
                        minSize = 300.dp,
                        maxSize = 600.dp,
                    ),
            )

        var isEditContact by rememberSaveable { mutableStateOf(false) }

        LaunchedEffect(Unit) {
            crmScreenModel.onEvent(CRMEvent.Toggle(crmState.selectedContactTab))
            navLinkState = navLinkState.copy(
                onRefresh = {
                    crmScreenModel.onEvent(CRMEvent.Toggle(crmState.selectedContactTab))
                    sidePanelState.sidePanelOpened = false
                },
            )
        }

        LaunchedEffect(sidePanelState.sidePanelOpened) {
            if (!sidePanelState.sidePanelOpened) {
                organizationScreenModel.onEvent(OrganizationEvent.ClearOrganizationState)
                contactScreenModel.onEvent(ContactEvent.ClearContactState)
                customFieldsScreenModel.onEvent(CustomFieldsEvent.ClearCustomFieldsState)
            }
        }

        LaunchedEffect(contactOrganizationState.addContactOrganization.isSuccess) {
            if (contactOrganizationState.addContactOrganization.isSuccess) {
                if (organizationState.organization.value.type == OrganizationModel.Type.TravelAgency)
                    crmScreenModel.onEvent(CRMEvent.GetOrganizationList("travel_agency")) else
                    crmScreenModel.onEvent(CRMEvent.GetOrganizationList("supplier"))

                contactOrganizationScreenModel.onEvent(ContactOrganizationEvent.ClearState)
                sidePanelState.sidePanelOpened = false
            }
        }

        @Composable
        fun contactDetailsSidePanelScreen() {
            Column(
                modifier = Modifier
                    .fillMaxHeight()
                    .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),

                ) {
                HeaderRow(
                    onIconClick = { sidePanelState.sidePanelOpened = false },
                    text = contactState.contact.value.prettyName,
                )

                ContactDetailsScreen(
                    state = contactState,
                    onEvent = contactScreenModel::onEvent,
                    onNavigation = {

                    },
                    validation = contactScreenModel.validation,
                    addressState = contactAddressState,
                    onAddressEvent = contactAddressScreenModel::onEvent,
                    addressValidation = contactAddressScreenModel.validation,
                    customFieldsState = customFieldsState,
                    travelAgentState = travelAgentState,
                    onCustomFieldsEvent = customFieldsScreenModel::onEvent,
                    isSaveEnabled = contactScreenModel.vm.isContactChanged() ||
                        contactAddressScreenModel.vm.isAddressChanged() ||
                        customFieldsScreenModel.vm.isCustomFieldsChanged(),
                )
            }
        }

        @Composable
        fun newContactSidePanelScreen() {
            Column(
                modifier =
                    Modifier
                        .fillMaxHeight()
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),
            ) {
                HeaderRow(
                    onIconClick = { sidePanelState.sidePanelOpened = false },
                    text = if (organizationState.organization.value.type == OrganizationModel.Type.TravelAgency)
                        "New Travel Agent" else if (organizationState.organization.value.type == OrganizationModel.Type.Supplier)
                        "New Supplier" else
                        "",
                )

                ContactOrganizationScreen(
                    state = contactOrganizationState,
                    onEvent = contactOrganizationScreenModel::onEvent,
                    organizationState = organizationState,
                    onOrganizationEvent = organizationScreenModel::onEvent,
                    organizationValidation = organizationScreenModel.validation,
                    organizationAddressState = organizationAddressState,
                    onOrganizationAddressEvent = organizationAddressScreenModel::onEvent,
                    organizationAddressValidation = organizationAddressScreenModel.validation,
                    contactState = contactState,
                    onContactEvent = contactScreenModel::onEvent,
                    contactValidation = contactScreenModel.validation,
                    contactAddressState = contactAddressState,
                    onContactAddressEvent = contactAddressScreenModel::onEvent,
                    contactAddressValidation = contactAddressScreenModel.validation,
                    customFieldsState = customFieldsState,
                    onCustomFieldsEvent = customFieldsScreenModel::onEvent,
                )
            }
        }

        SidePanel(
            sidePanelState = sidePanelState,
            isHorizontal = true,
            sidePanel = {
                if (isEditContact) {
                    contactDetailsSidePanelScreen()
                } else {
                    newContactSidePanelScreen()
                }
            },
            splitter =
                Splitter(
                    measuredPart = {
                        Box(
                            modifier = Modifier.width(1.spacing).fillMaxHeight(),
                        )
                    },
                ),
            modifier = Modifier.fillMaxSize(),
        ) {
            CRMScreen(
                state = crmState,
                onEvent = crmScreenModel::onEvent,
                onNavigation = {
                    when (it) {
                        is CRMNavigation.AddOrganization -> {
                            organizationScreenModel.onEvent(
                                OrganizationEvent.UpdateOrganizationFields(
                                    organization = organizationState.organization.value.copy(
                                        type = it.type,
                                    ),
                                ),
                            )

                            customFieldsScreenModel.onEvent(
                                CustomFieldsEvent.SetType(
                                    type = it.type,
                                ),
                            )
                            isEditContact = false
                            sidePanelState.sidePanelOpened = true
                        }

                        is CRMNavigation.Toggle -> {
                            organizationScreenModel.onEvent(
                                OrganizationEvent.ClearOrganizationState,
                            )

                            contactScreenModel.onEvent(
                                ContactEvent.ClearContactState,
                            )

                            customFieldsScreenModel.onEvent(
                                CustomFieldsEvent.ClearCustomFieldsState,
                            )

                            sidePanelState.sidePanelOpened = false
                        }

                        is CRMNavigation.OrganizationDetails -> {
                            navigator.safePush(
                                OrganizationDetailsScreenNav(
                                    organizationId = it.id,
                                ),
                            )
                        }

                        is CRMNavigation.EditContact -> {
                            contactScreenModel.onEvent(
                                ContactEvent.GetContact(
                                    it.contactId,
                                ),
                            )

                            customFieldsScreenModel.onEvent(
                                CustomFieldsEvent.SetType(
                                    type = OrganizationModel.Type.TravelAgency,
                                    it.contactId,
                                ),
                            )
                            isEditContact = true
                            sidePanelState.sidePanelOpened = true
                        }
                    }
                },
            )
        }
    }
}

@Composable
fun HeaderRow(
    onIconClick: () -> Unit,
    text: String,
) {
    Column {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .background(
                    color = MaterialTheme.esColorScheme.bgSecondary,
                    shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
                )
                .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                .padding(2.5f.spacing)
                .fillMaxWidth(),
        ) {
            EsMediumOutlineIconButton(
                onClick = onIconClick,
                iconRes = EsIcons.ArrowRight,
            )

            SelectionContainer {
                Text(
                    text = text,
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.h3Bold24,
                )
            }
        }

        Spacer(modifier = Modifier.height(1f.spacing))
    }
}

